import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {toggleLeftMenu} from '../../actions/layout';
import Drawer from 'material-ui/Drawer';
import withWidth, {LARGE} from 'material-ui/utils/withWidth';
import NavigationBar from './NavigationBar';

export class LoggedLayout extends React.Component {

  state = {
    isOpenLeftMenu: false
  };

  static propTypes = {
    toggleLeftMenu: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    headerTitle: PropTypes.string
    };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  getStyle() {
    const {navBar} = this.context.muiTheme;

    const style = {
      appBar: {
        width: 'auto',
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0
      },

      appBarBig: {
        left: navBar.openedWidth
      },

      app: {
        position: 'relative'
      },

      appBig: {
        paddingLeft: navBar.openedWidth
      },


      appContent: {
        width: '100%'
      },
      appContentBig: {}
    };

    if (this.isBigEnough()) {
      style.appContent = Object.assign(style.appContent, style.appContentBig);
      style.appBar = Object.assign(style.appBar, style.appBarBig);
      style.app = Object.assign(style.app, style.appBig);
    }

    return style;
  }

  handleToggle(isOpen) {
    this.setState({isOpenLeftMenu: isOpen || !this.state.isOpenLeftMenu});
  }

  isBigEnough() {
    return this.props.width === LARGE;
  }

  render() {
    let style = this.getStyle();
    let isBigEnough = this.isBigEnough();
    let {open, toggleLeftMenu} = this.props;
    const {navBar} = this.context.muiTheme;

    return (
      <div>
        <Drawer
          open={open || isBigEnough}
          docked={isBigEnough}
          onRequestChange={toggleLeftMenu}
          width={navBar.openedWidth}
          style={{display: 'flex', alignItems: 'stretch'}}
        >
          <NavigationBar onSelectItem={() => toggleLeftMenu(false)}/>
        </Drawer>
        <div style={style.app}>
          <div style={style.appContent}>
            <content>
              {this.props.children}
            </content>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({layout: {open}}) => ({
    open
  }),
  (dispatch) => ({
    toggleLeftMenu: () => dispatch(toggleLeftMenu())
  })
)(withWidth()(LoggedLayout));




// WEBPACK FOOTER //
// ./src/components/LoggedLayout/LoggedLayout.jsx